const cardItems = [
  {
    title: '《庆余年2》',
    subtitle: '范闲归来 · 庙堂风云再起',
    desc: '张若昀领衔原班人马回归，南庆朝堂暗流涌动。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20scholar%20figure%20in%20traditional%20robes%2C%20imperial%20court%20architecture%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20red%20tones%2C%20historical%20costume%20drama%20aesthetic%2C%20cinematic%20composition%20on%20dark%20background&width=360&height=500&seq=cards-qingyu&orientation=portrait',
    tag: '热播',
    score: '9.2',
  },
  {
    title: '《唐朝诡事录2》',
    subtitle: '奇幻探案 · 大唐奇谭',
    desc: '杨旭文杨志刚联手破解诡秘案件。',
    img: 'https://readdy.ai/api/search-image?query=Tang%20Dynasty%20Chinese%20mystery%20drama%20with%20ancient%20Chinese%20detectives%20in%20traditional%20costumes%2C%20moonlit%20night%20scene%2C%20lanterns%2C%20mysterious%20atmosphere%2C%20historical%20architecture%2C%20warm%20amber%20lighting%20with%20deep%20shadows&width=360&height=500&seq=cards-tangchao&orientation=portrait',
    tag: '悬疑',
    score: '8.8',
  },
  {
    title: '《玫瑰的故事》',
    subtitle: '刘亦菲 · 都市女性成长',
    desc: '神仙姐姐演绎现代女性情感蜕变之路。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20Chinese%20romance%20drama%20with%20beautiful%20woman%20silhouette%2C%20city%20skyline%20at%20sunset%2C%20roses%20scattered%2C%20warm%20romantic%20atmosphere%2C%20soft%20golden%20hour%20lighting%2C%20fashionable%20urban%20aesthetic%20on%20warm%20background&width=360&height=500&seq=cards-meigui&orientation=portrait',
    tag: '都市',
    score: '8.5',
  },
  {
    title: '《长相思2》',
    subtitle: '杨紫 · 上古虐恋再续',
    desc: '相柳夭玹修罗场，暑期档必看仙侠。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20with%20ethereal%20female%20figure%2C%20floating%20silk%20ribbons%2C%20ancient%20Chinese%20mythological%20atmosphere%2C%20cherry%20blossoms%2C%20soft%20dreamy%20lighting%2C%20celestial%20palace%20in%20background%2C%20romantic%20oriental%20aesthetic&width=360&height=500&seq=cards-changxiangsi&orientation=portrait',
    tag: '仙侠',
    score: '9.0',
  },
  {
    title: '《大奉打更人》',
    subtitle: '王鹤棣 · 穿越探案爽剧',
    desc: '现代刑警穿越古代，破奇案搅风云。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20with%20handsome%20male%20lead%20in%20dark%20official%20robes%2C%20night%20time%20ancient%20city%2C%20lanterns%20and%20shadows%2C%20mysterious%20detective%20atmosphere%2C%20dramatic%20candlelight%2C%20cinematic%20noir%20style%20with%20warm%20undertones&width=360&height=500&seq=cards-dafeng&orientation=portrait',
    tag: '穿越',
    score: '8.3',
  },
  {
    title: '《孤舟》',
    subtitle: '曾舜晞张颂文 · 谍战风云',
    desc: '民国谍战大戏，名门少爷的潜伏之路。',
    img: 'https://readdy.ai/api/search-image?query=Republican%20era%20Chinese%20spy%20drama%20with%20man%20in%20trench%20coat%2C%20rainy%20Shanghai%20street%201940s%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20noir%20atmosphere%2C%20smoke%20and%20shadows%2C%20vintage%20cinematic%20style%20with%20cool%20and%20warm%20contrast&width=360&height=500&seq=cards-guzhou&orientation=portrait',
    tag: '谍战',
    score: '8.7',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <i className="ri-grid-line text-accent-500 text-sm"></i>
            <span className="text-accent-400 text-xs font-medium">热门推荐</span>
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">当前热播剧集</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">
            精选六部全网热度最高的电视剧，免费高清秒开即播
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {cardItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-500/30 transition-all cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="360"
                  height="500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-950 text-xs font-semibold">
                    {item.tag}
                  </span>
                  <span className="px-2 py-1 rounded-md bg-background-50/80 backdrop-blur-sm text-primary-500 text-xs font-bold">
                    {item.score}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-950">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h4 className="text-foreground-800 font-heading font-bold text-sm mb-1">{item.title}</h4>
                <p className="text-foreground-400 text-xs mb-1.5">{item.subtitle}</p>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}